import axios from '../utils/axios';

const getAnnouncements = () => {
	return new Promise((resolve, reject) => {
		const url = '/api/announcements';
		axios.get(url)
			.then(({ data: { data } }) => {
				resolve(data);
			}).catch((err) => {
				reject(err);
			});
	});
};

export {
	getAnnouncements
};
